import { j as c } from "../../_virtual/jsx-runtime.js";
import { c as D } from "../../_virtual/compiler-runtime.js";
import { use as _, createContext as S } from "react";
import { Root as W, Provider as k, Trigger as q, Content as A, Portal as F } from "../../bundled_deps/.pnpm/@radix-ui_react-tooltip@1.2.8_@types_react-dom@19.2.3_@types_react@19.2.14__@types_reac_9074d9fb06315b089b2bee17c4c65951/bundled_deps/@radix-ui/react-tooltip/dist/index.js";
import { cn as z } from "../../utils/cn.js";
import { TooltipIcon as G } from "../icons/tooltip-icon.js";
import { PortalRootContext as J } from "../portal-root/portal-root-context.js";
import { firstComponentsByComponentName as B, filterOutComponentsByDisplayName as K } from "../../utils/components.js";
const E = S({});
E.displayName = "TooltipContext";
function I(n) {
  const e = D.c(26), {
    children: t,
    disabled: o,
    invertTheme: l,
    defaultOpen: i,
    open: s,
    onOpenChange: x,
    disableHoverableContent: j,
    position: b,
    align: h,
    sideOffset: g
  } = n, p = o === void 0 ? !1 : o, m = l === void 0 ? !1 : l, T = j === void 0 ? !1 : j, v = g === void 0 ? 4 : g;
  let r;
  e[0] === Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ c.jsx(G, {}), e[0] = r) : r = e[0];
  let a;
  e[1] !== p ? (a = /* @__PURE__ */ c.jsx($, { children: /* @__PURE__ */ c.jsx("button", { type: "button", disabled: p, className: "cursor-help", children: r }) }), e[1] = p, e[2] = a) : a = e[2];
  const f = a;
  let d;
  e[3] !== t || e[4] !== f ? (d = B(t, $.displayName) ?? f, e[3] = t, e[4] = f, e[5] = d) : d = e[5];
  const u = d;
  let O;
  e[6] !== t ? (O = B(t, H.displayName), e[6] = t, e[7] = O) : O = e[7];
  const P = O;
  let N;
  e[8] !== h || e[9] !== p || e[10] !== m || e[11] !== b || e[12] !== v ? (N = {
    disabled: p,
    position: b,
    align: h,
    sideOffset: v,
    invertTheme: m
  }, e[8] = h, e[9] = p, e[10] = m, e[11] = b, e[12] = v, e[13] = N) : N = e[13];
  let y;
  e[14] !== P || e[15] !== i || e[16] !== x || e[17] !== s || e[18] !== u ? (y = /* @__PURE__ */ c.jsxs(W, { defaultOpen: i, open: s, onOpenChange: x, children: [
    u,
    P
  ] }), e[14] = P, e[15] = i, e[16] = x, e[17] = s, e[18] = u, e[19] = y) : y = e[19];
  let C;
  e[20] !== T || e[21] !== y ? (C = /* @__PURE__ */ c.jsx(k, { disableHoverableContent: T, delayDuration: 0, children: y }), e[20] = T, e[21] = y, e[22] = C) : C = e[22];
  let R;
  return e[23] !== C || e[24] !== N ? (R = /* @__PURE__ */ c.jsx(E, { value: N, children: C }), e[23] = C, e[24] = N, e[25] = R) : R = e[25], R;
}
I.displayName = "Tooltip";
function $(n) {
  const e = D.c(2), {
    children: t
  } = n;
  let o;
  return e[0] !== t ? (o = /* @__PURE__ */ c.jsx(q, { asChild: !0, "data-testid": "tooltip-trigger", children: t }), e[0] = t, e[1] = o) : o = e[1], o;
}
$.displayName = "Tooltip.Trigger";
function H(n) {
  const e = D.c(27);
  let t, o, l;
  e[0] !== n ? ({
    children: t,
    className: o,
    ...l
  } = n, e[0] = n, e[1] = t, e[2] = o, e[3] = l) : (t = e[1], o = e[2], l = e[3]);
  const {
    position: i,
    align: s,
    sideOffset: x,
    disabled: j,
    invertTheme: b
  } = _(E), h = _(J);
  let g;
  e[4] !== t ? (g = B(t, w.displayName), e[4] = t, e[5] = g) : g = e[5];
  const p = g;
  let m;
  e[6] !== t ? (m = K(t, w.displayName), e[6] = t, e[7] = m) : m = e[7];
  const T = m;
  if (j)
    return null;
  const v = b && "inverse-theme";
  let r;
  e[8] !== o || e[9] !== v ? (r = z(v, "group z-50 overflow-hidden rounded-medium shadow-lvl-2 ring-1 ring-neutral-border", o), e[8] = o, e[9] = v, e[10] = r) : r = e[10];
  let a;
  e[11] !== o ? (a = z("relative z-10 max-w-[300px] rounded bg-base-module px-3 py-2 text-support text-default flex flex-col gap-1", o), e[11] = o, e[12] = a) : a = e[12];
  let f;
  e[13] !== T || e[14] !== l || e[15] !== a || e[16] !== p ? (f = /* @__PURE__ */ c.jsxs("div", { ...l, className: a, children: [
    p,
    T
  ] }), e[13] = T, e[14] = l, e[15] = a, e[16] = p, e[17] = f) : f = e[17];
  let d;
  e[18] !== s || e[19] !== i || e[20] !== x || e[21] !== r || e[22] !== f ? (d = /* @__PURE__ */ c.jsx(A, { side: i, align: s, sideOffset: x, className: r, hideWhenDetached: !0, "data-testid": "tooltip-content", children: f }), e[18] = s, e[19] = i, e[20] = x, e[21] = r, e[22] = f, e[23] = d) : d = e[23];
  let u;
  return e[24] !== h || e[25] !== d ? (u = /* @__PURE__ */ c.jsx(F, { container: h, children: d }), e[24] = h, e[25] = d, e[26] = u) : u = e[26], u;
}
H.displayName = "Tooltip.Content";
function w(n) {
  const e = D.c(10);
  let t, o, l;
  e[0] !== n ? ({
    children: t,
    className: o,
    ...l
  } = n, e[0] = n, e[1] = t, e[2] = o, e[3] = l) : (t = e[1], o = e[2], l = e[3]);
  let i;
  e[4] !== o ? (i = z("text-support-bold", o), e[4] = o, e[5] = i) : i = e[5];
  let s;
  return e[6] !== t || e[7] !== l || e[8] !== i ? (s = /* @__PURE__ */ c.jsx("div", { className: i, "data-testid": "tooltip-title", ...l, children: t }), e[6] = t, e[7] = l, e[8] = i, e[9] = s) : s = e[9], s;
}
w.displayName = "Tooltip.Title";
const ee = Object.assign(I, {
  Trigger: $,
  Content: H,
  Title: w
});
export {
  ee as Tooltip
};
